export default [
  'login',
  'edu-dashboard',
  'school-dashboard',
  'camera-video',
  'schooltv-tv'
]
